import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { HttpClient } from '@angular/common/http';
import { GfTitleService } from '../../../core/services/core.title.service';
import { gfDateFunction } from '../../../core/pipes/date/date.functions';
import * as _ from 'lodash';
import { normalizeCommitish } from '../services/scm.utils';

@Component({
  selector: 'scm-commit-list',
  template: require('./scm.commits.component.html'),
})
export class ScmCommitListComponent implements OnInit {
  page_num = 1;
  @Input() project: any;
  @Input() scm: any;
  @Input() breadcrumbs: any;

  commits: any = false;
  firstRecord: number = 1;
  lastRecord: number = 20;
  displayCommits: any = false;
  unixName: string;
  commitish: string = '';
  module: string;

  constructor(
    protected stateService: StateService,
    private http: HttpClient,
    private titleService: GfTitleService,
  ) {}

  ngOnInit() {
    const params = this.stateService.params;
    this.unixName = params['unixName'];
    this.commitish = normalizeCommitish(
      params['branch'] ||
      params['tag'] ||
      params['commit'] ||
      _.get(this.scm, 'defaultBranchName', '')
    );
    if (this.scm.scmType === 'cvs') {
      this.module = params['module'];
    }

    this.titleService.setTitle(this.project.name, _.startCase(this.scm.scmType) + ' Commits');
    this.refreshData();
  }

  refreshData() {
    const params = this.stateService.params;
    const pageNum = params['page_num'] || 1;
    this.page_num = _.toInteger(pageNum);
    const branchParam = encodeURIComponent(this.commitish);
    const commitishParam = params['tag'] ? 'tag' : (params['commit'] ? 'commit' : 'branch');
    let url = `/api/scm/${params['unixName']}/commit/?${commitishParam}=${branchParam}&page_num=${pageNum}`;

    if (this.scm.scmType === 'cvs') {
      url += `&module=${encodeURIComponent(params['module'])}`;
    }

    this.http
      .get(url)
      .toPromise()
      .then((response: any) => {
        this.commits = _.get(response, 'items', []);
      },() => {
        this.commits = [];
      })
      .then(() => {
        this.displayCommits = this.getDisplayCommits();
        this.firstRecord = (pageNum - 1) * 20 + 1;
        this.lastRecord = this.firstRecord + (this.commits.length - 1);
      });
  }

  getDisplayCommits() {
    if (this.commits) {
      return Object.entries(_.groupBy(this.commits, ($item) => {
        return gfDateFunction($item.commitDate, 'll');
      }));
    } else {
      return false;
    }
  }

  paramsForPrevPage() {
    const params = { ...this.stateService.params };
    params['page_num'] = _.toInteger(params['page_num'] || 1);
    params['page_num'] = Math.max(params['page_num'] - 1, 1);
    return params;
  }

  paramsForNextPage() {
    const params = { ...this.stateService.params };
    params['page_num'] = _.toInteger(params['page_num'] || 1) + 1;
    return params;
  }
}
